import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '@core/services';

@Pipe({
  name: 'infoDrugRouterLink'
})
export class InfoDrugRouterLinkPipe implements PipeTransform {

  constructor(
    private readonly localizationService: LocalizationService
  ) {}

  transform(product: { id: number, url: string }): string {
    return this.localizationService.getRouterLinkApp('info-drug/' + product.url + '/' + product.id);
  }

}
